import react, { useEffect, useRef } from "react";
import { Map } from "@neshan-maps-platform/ol";
import NeshanMap from "@neshan-maps-platform/react-openlayers";
import "@neshan-maps-platform/react-openlayers/dist/style.css";
import neshan from '../assetss/img/map/neshan.png'
import balad from '../assetss/img/map/balad.png'
import google from '../assetss/img/map/google.jpg'

const Location = () => {
  // const map = new Map()
  return (
    <div className="dark:bg-gray-800 min-h-screen">
      <NeshanMap
        className=""
        mapKey="web.0b434a73505744e4a8f1993d5a0a536a"
        center={{ latitude: 35.713613925057594, longitude: 51.44777355819193 }}
        zoom={17}
        defaultType="neshan"
        style={{ height: "48vh", width: "100%" }}
        traffic={true}
        poi={true}
        // View={true}
      ></NeshanMap>
      <div className=" flex flex-col  my-4 dark:text-white ">
        <p className="dark:text-white text-center">مسیریابی با</p>
        <div className="flex justify-center gap-10 items-center mt-8">
          <a target="_blank" href="https://nshn.ir/rbvHBPPxuVy3">
            <span className="flex flex-col w-16 h-16 justify-center text-center gap-2">
              <p>نشان</p>
              <img className="rounded-lg" src={neshan} alt="" />
            </span>
          </a>
          <a target="_blank" href="https://maps.app.goo.gl/qkgRZCmCrbfxQviF8">
          <span className="flex flex-col w-16 h-16 justify-center text-center gap-2">
              <p>گوگل</p>
              <img className="rounded-lg" src={google} alt="" />
            </span>
          </a>
          <a
            target="_blank"
            href="https://balad.ir/location?latitude=35.713534&longitude=51.447725&zoom=16.500000"
          >
            <span className="flex flex-col w-16 h-16 justify-center text-center gap-2">
              <p>بلد</p>
              <img className="rounded-lg" src={balad} alt="" />
            </span>
          </a>
        </div>
        <p className="my-8 text-center" >آدرس : خواجه نظام ابتدای کوچه شهیدین</p>
      </div>
    </div>
  );
};

export default Location;
